import { render, staticRenderFns } from "./trainBoxleft.vue?vue&type=template&id=ca4f475a&scoped=true&"
import script from "./trainBoxleft.vue?vue&type=script&lang=js&"
export * from "./trainBoxleft.vue?vue&type=script&lang=js&"
import style0 from "./trainBoxleft.vue?vue&type=style&index=0&id=ca4f475a&lang=scss&scoped=true&"
import style1 from "./trainBoxleft.vue?vue&type=style&index=1&id=ca4f475a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4f475a",
  null
  
)

export default component.exports